import _ from 'lodash';

import domains from '../containers/Domains';
import contextMakePost from './Context';

const endpoint = domains.fbEndpoint;

export const copyAdSet = async (data, token) => {
  const parameters = {
    access_token: token,
    deep_copy: false,
    campaign_id: data.campaign_id,
    start_time: data.start_time,
    end_time: data.end_time
  };

  const id = `${data.adset}/copies`;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const getAdSet = async (adset, token) => {
  const parameters = {
    access_token: token,
    adset_id: adset,
    fields:
      'id,name,start_time,end_time,ads{id,status,name,creative{object_story_spec,url_tags,product_set_id}}'
  };

  const query = _.template(
    `${endpoint}<%= adset_id%>?fields=<%= fields%>&access_token=<%= access_token%>`
  );
  const result = await fetch(query(parameters));
  return result.json();
};

export const updateAdSet = async (data, token) => {
  const parameters = {
    access_token: token,
    name: data.name,
    status: 'ACTIVE'
  };

  const id = data.id;
  const result = await contextMakePost(parameters, id);
  return result;
};

export const getAdSets = async (campaignId, token) => {
  const parameters = {
    access_token: token,
    campaign_Id: campaignId,
    fields: 'id,name&limit=100'
  };

  const query = _.template(
    `${endpoint}<%= campaign_Id%>/adsets?fields=<%= fields%>&access_token=<%= access_token%>`
  );
  const result = await fetch(query(parameters));
  return result.json();
};

export const createAdSet = async (accountId, parameters) => {
  const id = `act_${accountId}/adsets`;
  const result = await contextMakePost(parameters, id);
  return result.json();
};



// WEBPACK FOOTER //
// ./src/fbApi/AdSet.js